import { useState } from 'react';

interface RegenerateMapButtonProps {
  scene: unknown;
}

export default function RegenerateMapButton({ scene }: RegenerateMapButtonProps) {
  const [isRegenerating, setIsRegenerating] = useState(false);

  const handleRegenerate = async () => {
    if (!scene || typeof scene !== 'object' || isRegenerating) return;

    setIsRegenerating(true);
    console.info('[Map Regeneration] Starting map regeneration...');
    const startTime = performance.now();

    try {
      const typedScene = scene as { regenerateMap?: () => Promise<void> };
      if (typedScene.regenerateMap) {
        await typedScene.regenerateMap();
        const endTime = performance.now();
        console.info(`[Map Regeneration] Completed in ${(endTime - startTime).toFixed(2)}ms`);
      } else {
        console.warn('[Map Regeneration] regenerateMap is not available on the scene.');
      }
    } catch (error) {
      console.error('[Map Regeneration] Error regenerating map:', error);
    } finally {
      setIsRegenerating(false);
    }
  };

  return (
    <button
      onClick={handleRegenerate}
      disabled={isRegenerating}
      className={`px-4 py-2 rounded transition-colors ${
        isRegenerating
          ? 'bg-gray-500 cursor-not-allowed text-gray-300'
          : 'bg-blue-700 hover:bg-blue-600 text-white'
      }`}
      aria-label={isRegenerating ? 'Regenerating map...' : 'Regenerate map'}
    >
      {isRegenerating ? 'Regenerating...' : 'Regenerate Map'}
    </button>
  );
}
